export default __webpack_public_path__ + "static/media/logo1-nobg.9e6affa5.png";